
import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 py-6">
      <div className="container">
        <div className="mb-6 rounded-xl bg-gradient-to-r from-primary-50 via-white to-secondary-50 p-6 border border-gray-100 shadow-sm">
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 text-center">
            <Heart className="h-5 w-5 text-primary animate-pulse" />
            <p className="text-sm md:text-base font-medium text-gray-700 italic">
              Built on the foundation of my parents' dreams, sacrifices, and belief in the power of learning.
            </p>
            <Heart className="h-5 w-5 text-primary animate-pulse" />
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <p className="text-sm text-muted-foreground">
              &copy; {currentYear} Cibeto Technologies Private Limited. All rights reserved.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm text-muted-foreground">
            <Link to="/privacy-policy" className="hover:text-foreground transition-colors">
              Privacy
            </Link>
            <Link to="/terms-and-conditions" className="hover:text-foreground transition-colors">
              Terms
            </Link>
            <Link to="/cookie-policy" className="hover:text-foreground transition-colors">
              Cookies
            </Link>
            <Link to="/about-us" className="hover:text-foreground transition-colors">
              About
            </Link>
            <Link to="/contact-us" className="hover:text-foreground transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
